{
	"accounts": "Accounts",
	"invitations": "Uitnodigingen",
	"subscribeToFeedback": "Meld je aan voor het feedbackprogramma",
	"notificationSettings": {
		"title": "Instellingen voor e-mailmeldingen",
		"invoicingInformation": "Factuurinformatie",
		"declarationProcessingStatus": "Verwerkingsstatus van declaratie",
		"enabled": "Aan",
		"disabled": "Uit",
		"toast": {
			"success": "Meldingsvoorkeur bijgewerkt",
			"error": "Meldingsvoorkeur kon niet worden bijgewerkt"
		}
	},
	"about": {
		"title": "Over",
		"termsAndConditions": "Algemene voorwaarden",
		"privacyPolicy": "Privacybeleid",
		"imprint": "Colofon",
		"openSourceAttribution": "Open-sourcevermelding"
	},
	"language": {
		"title": "Taal",
		"footer": "Taalwijzigingen worden doorgevoerd in alle Heidelberg Materials-applicaties"
	},
	"impressum": "Colofon",
	"copyright": "© 2024 Heidelberg Materials. Alle rechten voorbehouden.",
	"login": "Inloggen",
	"logout": "Uitloggen"
}
